
import { Component, Prop, Vue } from 'vue-property-decorator';
import DropDown from './DropDown.vue';
import BaseComponent from '@/author/components/BaseComponent.vue';
import { VNode } from 'vue';
import KnowledgeCheckEvents from '@/author/components/KnowledgeCheckParts/KnowledgeCheckEvents.vue';
import {KNOWLEDGE_CHECK_EVENTS} from '@/author/constants';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import { getModule } from 'vuex-module-decorators';
import Timer from 'easytimer.js';
const AppState = getModule(AppModule, store);

@Component
export default class DropDownList extends BaseComponent {
  @Prop() title!: string;

  @Prop() dropDownsInstructions!: string;
  @Prop() submitLabel!: string;
  @Prop() tryAgainLabel!: string;
  @Prop() hiddenFeedbackText!: string;
  @Prop({default: true }) textualFeedback!: boolean;
  @Prop({default: 'Answer Summary'}) feedbackTitle!: string;
  @Prop({default:'left'}) feedbackTitleAlign!: string;
  @Prop() feedbackText!: string;
  @Prop({default:'left'}) feedbackTextAlign!: string;
  @Prop({default: false}) showDetailedAnswersForNeutral!:boolean
  @Prop({default: false}) showDetailedAnswersForWrong!:boolean
  @Prop({default: false}) blocking!:boolean

  @Prop() correctTitle!: string;
  @Prop() correctFeedback!: string;
  @Prop() correctFeedbackImage!: string;
  @Prop() incorrectTitle!: string;
  @Prop() incorrectFeedback!: string;
  @Prop() incorrectFeedbackImage!: string;

  @Prop(String) feedbackBackgroundImage!: string;
  @Prop({ type: String, default: 'no-repeat' }) feedbackBackgroundRepeat!: string;
  @Prop({ type: String, default: 'cover' }) feedbackBackgroundSize!: string;
  @Prop({ type: String, default: 'center' }) feedbackBackgroundPosition!: string;
  @Prop(String) feedbackBackgroundColor!: string; 

  public $refs!: {
    feedbackStage: HTMLElement; 
  };
  isInteractive :boolean = true;
  sessionTimer : Timer = new Timer();

  rightCount: number = 0;
  neutralCount: number = 0;
  wrongCount: number = 0;
  submited: boolean = false;

  dropdowns!: DropDown[];
  allChosen: boolean = false;
  hasVideo: boolean = false;

  created() {
    KnowledgeCheckEvents.$on(KNOWLEDGE_CHECK_EVENTS.MOUNTED, this.mountChildren);
    this.lockForward();
  }

  mounted(){
    KnowledgeCheckEvents.$on(KNOWLEDGE_CHECK_EVENTS.OPTION_SELECTED, this.dropChosen);
    this.sessionTimer.start();
  }

  beforeDestroy(){
    KnowledgeCheckEvents.$off([KNOWLEDGE_CHECK_EVENTS.OPTION_SELECTED, KNOWLEDGE_CHECK_EVENTS.MOUNTED]);
  }

  mountChildren() {
    let dropdowns : any[] = (this.$children as any)[0].$children.filter(this.isDropdown);
    if (dropdowns !== undefined && dropdowns.length > 0) 
      this.dropdowns = dropdowns;
    
  }

  dropChosen() {
    this.allChosen = this.isAllChosen();
  }

  submit() {
    this.rightCount = 0;
    this.neutralCount = 0;
    this.wrongCount = 0;
    this.dropdowns.map(drp => {
      if (drp.isRight) this.rightCount += 1;
      else if (drp.isNeutral) this.neutralCount += 1;
      else this.wrongCount += 1;
      drp.markAsSubmited();
    });
    this.submited = true;
    if(!this.blocking || this.wrongCount === 0 )
      this.unlock();
    setTimeout(()=>{
      let title = document.getElementById('answer-title');
      if(title)
        title.focus();
      else{
        this.$refs.feedbackStage.focus();        
        document.querySelector('.feedback-stage > *')?.setAttribute('role','alert');
        document.querySelector('.feedback-stage > * > *')?.setAttribute('role','complementary');
      }
      this.hasVideo = this.checkVideo();
    },200);
    this.sessionTimer.reset();
  }

  isAllChosen(): boolean {
    return this.dropdowns && this.dropdowns.length > 0
      ? this.dropdowns.every(dr => dr.getChosen !== null)
      : false;
  }

  isDropdown(component: any){
    return component.$options && component.$options._componentTag.toLowerCase() === 'dropdown';
  }

  tryAgain(){
    this.dropdowns.map(drp => {
      drp.resetOption();
    });
    this.submited = false;
  }

  get getGeneralFeedback(): object[] {
    return this.dropdowns.map(drp => ({
      title: drp.title,
      question: drp.question,
      preLinkFeedback: drp.preLinkFeedback,
      postLinkFeedback: drp.postLinkFeedback,
      linkHref: drp.linkHref,
      linkText: drp.linkText,
      chosen: drp.getChosen ? drp.getChosen.text : null,
      isRight: drp.isRight,
      isWrong: drp.isWrong,
      isNeutral: drp.isNeutral,
      options: drp.options.map(option => ({
        text: option.text,
        type: option.answerType
      }))
    }));
  }

  get isSubmitDisabled():boolean{
    return !this.allChosen || this.submited;
  }
  checkVideo(){
    return !!document.getElementById('VideoPlayer');
  }
}
